import { AxiosResponse } from 'axios';

import { LogoutType } from 'shared/clients/client-spa-AccountGroup';
import { SsoConfig } from 'shared/typings/appSettings';

import type { AuthModel } from '../models/authorizationState.model';
import { BEFORE_CONTEXT_CHANGE_ACTION } from '../models/beforeContextChangeAction';
import { Profile } from '../services/Authorization.contracts';
import AuthorizationModuleService from '../services/authorizationModule.service';
import AuthorizationModuleStore from './authorizationModule.store';

class AuthorizationModuleFacade {
  get accessToken(): string | undefined {
    return AuthorizationModuleStore.UserAccessToken;
  }

  get isUserLogged(): boolean {
    return !!AuthorizationModuleStore.UserCurrentAuthorizationState?.isLogged;
  }

  get getAuthMethod() {
    return AuthorizationModuleStore.getAuthMethod;
  }

  getUserAuthDataFromSessionStorage() {
    return AuthorizationModuleStore.UserCurrentAuthorizationState;
  }

  clearAuthorizationState() {
    return AuthorizationModuleStore.clearAuthorizationState();
  }

  async beforeContextChange() {
    return Promise.resolve(BEFORE_CONTEXT_CHANGE_ACTION.CONTINUE);
  }

  setBeforeContextChange(beforeContextChange: () => Promise<BEFORE_CONTEXT_CHANGE_ACTION>) {
    this.beforeContextChange = beforeContextChange;
  }

  resetBeforeContextChange() {
    this.beforeContextChange = () => Promise.resolve(BEFORE_CONTEXT_CHANGE_ACTION.CONTINUE);
  }

  async getTokenForChatBot(
    ssoConfig: SsoConfig,
    errorCallback = (error: any) => error
  ): Promise<AxiosResponse | void> {
    try {
      return await AuthorizationModuleService.getTokenForChatBot(ssoConfig, this.accessToken);
    } catch (e) {
      errorCallback(e);
    }
  }
  
  async loginAsOrganization(
    organizationNip: string,
    ssoConfig: SsoConfig,
     
    successCallback = () => {},
    errorCallback = (error: any) => error
  ): Promise<void> {
    const beforeContextChangeAction = await this.beforeContextChange();
    if (beforeContextChangeAction === BEFORE_CONTEXT_CHANGE_ACTION.STOP) {
      return;
    }

    try {
      AuthorizationModuleService.loginAsOrganization(organizationNip);
      successCallback();
    } catch (e) {
      errorCallback(e);
    }
  }

   
  async loginAsNaturalPerson(ssoConfig: SsoConfig, successCallback = () => {}, errorCallback = (error: any) => error): Promise<void> {
    const beforeContextChangeAction = await this.beforeContextChange();
    if(beforeContextChangeAction === BEFORE_CONTEXT_CHANGE_ACTION.STOP) {
      return;
    }
    try {
      AuthorizationModuleService.loginAsNaturalPerson();
      successCallback();
    } catch (e) {
      errorCallback(e);
    }
  }

   
  logout(logoutType: LogoutType, callback = () => {}) {
    AuthorizationModuleStore.clearAuthorizationState();
    AuthorizationModuleService.clearOrgId();
    AuthorizationModuleService.postLogoutMessage(logoutType);
    callback();
  }

  setUserAuth (authObj: AuthModel | any) {
    return AuthorizationModuleStore.setUserAuth(authObj);
  }

  public get UserCurrentAuthorizationState() {
    return AuthorizationModuleStore.UserCurrentAuthorizationState;
  }

  public get UserIdToken() {
    return AuthorizationModuleStore.UserIdToken;
  }

  public get UserProfile(): Profile | undefined {
    return AuthorizationModuleStore.UserProfile;
  }

  public get RedirectName(): string | undefined {
    return AuthorizationModuleStore.State?.redirectName;
  }

  public get ExpiresAt() {
    return AuthorizationModuleStore.ExpiresAt;
  }

  public get AuthErrorState() {
    return AuthorizationModuleStore.authErrorState;
  }

  public get UserAccessToken() {
    return AuthorizationModuleStore.UserAccessToken;
  }

  public get UserAccessTokenComputedRef() {
    return AuthorizationModuleStore.UserAccessTokenComputedRef;
  }

  public get UserSid() {
    return AuthorizationModuleStore.userSid;
  }

  public get UserMid() {
    return AuthorizationModuleStore.userMid;
  }

  public get isOrganization() {
    return AuthorizationModuleStore.isOrganization;
  }
}

export default new AuthorizationModuleFacade;
